module.exports = __webpack_public_path__ + "static/story-99e423cf06734a2231c1263139da7671.png";